export default __webpack_public_path__ + "static/media/NRLevel3RightSideMap.ce1e5ba2.jpg";